module.exports = __webpack_public_path__ + "img/20170704_135648_085.e738b146.jpg";